import {Module} from '@nestjs/common';
import {ConfigModule} from '@nestjs/config';
import configuration from './config/configuration';
import {ChatModule} from './modules/chat/chat.module';
import {McpModule} from './modules/mcp/mcp.module';
import {AgentModule} from './modules/agent/agent.module';

/**
 * Coda Server 根模块
 * 统筹加载聊天、MCP 文件操作与智能体调度模块
 */
@Module({
  imports: [
    ConfigModule.forRoot({
      isGlobal: true, // 设置为全局模块，所有子模块无需重复引入
      load: [configuration],
    }),
    ChatModule,
    McpModule,
    AgentModule,
  ],
})
export class AppModule {}
